import { Component, OnInit } from '@angular/core';
import {AdoptionService} from '../../services/adoption.service';
import {Adoption} from '../../classes/adoption.interface';
import {ActivatedRoute, Router, Params } from '@angular/router';
import {Breed} from '../../classes/breed.interface';
import { CommonService } from '../../services/common.service';
import { MatSnackBar } from '@angular/material';
import { VerifymobileComponent} from '../../usersettings/verifymobile/verifymobile.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import {AdoptionrequestdetailComponent} from '../adoptionrequestdetail/adoptionrequestdetail.component'
@Component({
  selector: 'app-knowme',
  templateUrl: './knowme.component.html',
  styleUrls: ['./knowme.component.css']
})
export class KnowmeComponent implements OnInit {
  userStatus: number;
  umobile: any;
  uname: any;
  totalrequest: any;
  adoptionrequest = [];
  action: any;
  adoptiondoc: any;
  city: Location[];
  userid: any;
  rflag: any;
  adoption: any;
  post_id: number;
  breed: Breed[];
  contactno: any;
  location: any;
  public loading = false;
  msg: any;
  adoprequestflag = 0;
  photo = [];
  requsername = [];
  constructor(private adoptionService: AdoptionService, private route: ActivatedRoute, private commonService:
    CommonService, private router: Router, private snackbar: MatSnackBar, public dialog: MatDialog) {
      window.scrollTo(0, 0);
    this.route.params.subscribe(params => {
      const id = +params['id'];
       this.post_id = id;
       this.rflag = params['type'];
       });
       this.userStatus = this.commonService.checkUserStatus();
       if (this.userStatus === 1) {
        const udata = this.commonService.getUserDataLocally();
        this.userid = udata.uid;
        this.uname = udata.uid;
        this.umobile = udata.umobile;
        this.alreadySentRequestForAdoption();
       }
   }

  ngOnInit() {
    this.loading = true;
    this.getPostDetail();
    this.getAllBreeds();
    this.getAdoptionCity();
    this.getAdoptionDocuments();
    if (this.userStatus === 1) {
      this.getAdoptionRequest();
    }
  }
  getPostDetail() {
    this.adoptionService.getPostDetail(this.post_id)
    .subscribe(
     (x) => {
       this.loading = false;
       this.adoption = x;
       this.getAdoptionLocation(this.adoption.city_id);
      });
  }
  getAllBreeds() {
    this.adoptionService.getBreeds()
    .subscribe(
     (x: Breed[]) => {
       this.breed = x;
     });
  }
    getAdoptionCity() {
      this.adoptionService.getAdoptionCity()
      .subscribe(
        (x) => {
          this.loading = false;
          this.city = x;
        }
      );
    }
    getAdoptionLocation(lid) {
      this.loading = true;
      this.adoptionService.getLocation(lid)
      .subscribe(
        (x) => {
          this.loading = false;
          this.location = x;
        }
      );
    }
    getAdoptionDocuments() {
      this.adoptionService.getDocumentForParticularAdoption(this.post_id)
      .subscribe(
        (x) => {
          this.adoptiondoc = x;
        }
      );
    }
    getFileExtension(fname) {
      return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2);
    }
    redirectBack() {
      if (this.rflag === 'adoption') {
        this.router.navigate(['/petadoption/home']);
      }
      if (this.rflag === 'manageprofile') {
        this.router.navigate(['/manageprofile/adoption']);
      }
    }
    changeAdoptionStatus() {
      this.loading = true;
      this.adoptionService.changeAdoptionStatus(this.adoption.id)
      .subscribe(
        (x) => {
          this.loading = false;
          this.msg = 'Status Updated';
          this.adoption.adoptionstatus = 'adopted';
          this.openSnackBar();
        });
    }
    openSnackBar() {
      this.snackbar.open(this.msg , this.action, {
        duration: 4000,
      });
    }
    goToAdoptionrequestForm(id) {
      const flag = 5;
      localStorage.setItem('adopreq', id);
      this.commonService.setActivatepath(flag);
      this.router.navigate(['/petadoption/adoptionrequest/' + id]);
    }
    alreadySentRequestForAdoption() {
      this.adoptionService.alreadySentRequestForAdoption(this.post_id, this.userid) 
      .subscribe(
        (x) => {
          const adopreq = x;
          if ( adopreq.length > 0  ) {
            this.adoprequestflag = 1;
          }
        });
    }
    getAdoptionRequest() {
      this.loading = true;
        this.adoptionService.getRequestForPerticularPost(this.post_id)
        .subscribe(
          (x) => {
            this.adoptionrequest = x;
            this.loading = false;
            this.totalrequest = this.adoptionrequest.length;
            for (let i= 0 ;i <this.adoptionrequest.length ; i++) {
              this.getrequesteduserDetail( this.adoptionrequest[i].contacteduser_id)
            }
          });
    }
    getrequesteduserDetail(sid) {
      this.commonService.getParticularDummyUser(sid)
      .subscribe(
        (x) => {
          const user = x;
          this.requsername['id' + user[0].user_id] = user[0].name;
          this.photo['id' + user[0].user_id] = user[0].image;
      });
    }
    verifyMobile() {
      const otp = this.getRandomArbitrary(1000, 9000);
      this.loading = true;
      this.commonService.createOtp(this.userid, otp)
      .subscribe(
         (x) => {
           this.loading = false;
          this.commonService.sendOtp(this.uname, this.umobile, otp);
          this.openOtpForm();
        }
      );
    }
    getRandomArbitrary(min, max) {
      const num = min + Math.random() * max;
     return Math.trunc(num);
  }
  openOtpForm() {
    const dialogRef = this.dialog.open(VerifymobileComponent, {
      width: '400px',
      height: '400px',
      data: {uid: this.userid}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.updateAdoptionStatus();
      }
    });
  }
  updateAdoptionStatus() {
    this.loading = true;
    this.adoptionService.updateAdoptiondata(this.adoption.id, 'waiting For Verification')
    .subscribe(
      (x) => {
        this.loading = false;
        this.adoption.adoptionstatus = 'waiting For Verification';
        this.msg = 'Mobile Verified And Post Successfully Uploaded';
        this.openSnackBar();
      });
  }
  manageRequest(rid, uid) {
    const dialogRef = this.dialog.open(AdoptionrequestdetailComponent, {
      width: '60%',
      height: '95%',
      data: {uid: uid, formid: rid}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
       this.getAdoptionRequest();
      }
    });
  }
}
